/* Copyright (c) 2022-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import CopyToClipboard from "react-copy-to-clipboard";
import { Button } from "@nordcloud/gnui";
import { SUCCESS_TEXT } from "~/constants";
import { showInfo } from "~/services/toast";

type Props = {
  value: string;
};

export function DetailCopyClipboard({ value }: Props) {
  return (
    <CopyToClipboard
      text={value}
      onCopy={() => {
        showInfo(SUCCESS_TEXT.copied);
      }}
    >
      <Button
        icon="copy"
        size="md"
        severity="low"
        css={{ visibility: "hidden" }}
      />
    </CopyToClipboard>
  );
}
